/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState, useRef } from 'react';
import { navDropdownData } from './NavbarData';
import { DropdownLayouts } from './DropdownLayout';
import { getDropdownLeft, getArrowPosition, getDropdownWidth } from './NavbarUtils';


interface NavbarHoverProps {
  navId: string;
  isVisible: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

const NavbarHover: React.FC<NavbarHoverProps> = ({
  navId,
  isVisible,
  onMouseEnter,
  onMouseLeave
}) => {
  const [dropdownPosition, setDropdownPosition] = useState({ left: 0, width: 0 });
  const dropdownRef = useRef<HTMLDivElement>(null);

  const dropdownData = navDropdownData[navId];
  
  if (!dropdownData || !isVisible) return null;

  // Calculate dropdown position based on hovered nav item
  useEffect(() => {
    if (navId && isVisible) {
      const navElement = document.querySelector(`[data-nav-id="${navId}"]`);
      if (navElement) {
        const rect = navElement.getBoundingClientRect();
        const navbarRect = document.querySelector('nav')?.getBoundingClientRect();
        
        if (navbarRect) {
          const leftPosition = rect.left - navbarRect.left;
          const itemWidth = rect.width;
          
          setDropdownPosition({
            left: leftPosition, // Direct alignment under nav item
            width: itemWidth
          });
        }
      }
    }
  }, [navId, isVisible]);

  const actualLeft = getDropdownLeft(dropdownRef.current, dropdownPosition.left);
  const arrowPos = getArrowPosition(dropdownPosition, actualLeft);

  return (
    <div
      ref={dropdownRef}
      className={`fixed ${getDropdownWidth(navId)} bg-white shadow-2xl border border-gray-100 rounded-lg z-40`}
      style={{
        top: '140px', // Fixed top position just below navbar
        left: `${actualLeft}px`,
        animation: isVisible ? 'fadeInDown 0.3s ease-out forwards' : 'fadeOutUp 0.2s ease-in forwards'
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {/* Arrow pointing to the nav item */}
      <div 
        className="absolute -top-2 w-4 h-4 bg-white border-l border-t border-gray-100 transform rotate-45"
        style={{
          left: `${arrowPos}px`,
          display: dropdownPosition.left >= 0 ? 'block' : 'none'
        }}
      ></div>
      
      {/* Main dropdown container */}
      <div className="px-6 py-4 relative">
        <DropdownLayouts navId={navId} dropdownData={dropdownData} />
      </div>
      
      {/* Enhanced decorative bottom border */}
      <div className="h-1 bg-gradient-to-r from-navgreen via-green-500 to-green-800 rounded-b-lg"></div>
    </div>
  );
};

export default NavbarHover;